<template>
  <section class="content">
    <div class="p-fluid p-formgrid p-grid">
      <div class="p-field p-col-12 p-col-12">
        <DataTable :value="itemSubGroupLists" :paginator="true" :rows="10"
                   paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                   :rowsPerPageOptions="[10,20,50]"
                   class="p-datatable-responsive p-datatable-gridlines" data-key="id">
          <Column header="S.n">
            <template #body="slotProps">
              {{ slotProps.index + 1 }}
            </template>
          </Column>
          <Column header="Item Group" field="groupName" filterField="groupName" filterMatchMode="contains">
            <template #body="sl">
              {{sl.data.itemGroupId.name}}
            </template>
          </Column>
          <Column header="Item Sub Group" field="name" filterField="name" filterMatchMode="contains"/>
          <Column header="Action">
            <template #body="slotProps">
              <!-- &nbsp;<Button type="button" class="btn btn-success" @click="editItemSubGroup(slotProps.data)">
                <i class="fa fa-edit" /></Button>
              &nbsp;&nbsp;
                 <Button class="btn btn-danger" v-if="!slotProps.data.systemOnly"
                   @click="openDialog(slotProps.data.id)" >
                    <i class="fa fa-trash" aria-hidden="true"></i>
                  </Button><Button class="btn btn-danger" v-else @click="openDialog(slotProps.data.id)" disabled>
                    <i class="fa fa-trash" aria-hidden="true"></i>
                    </Button> -->

              <Button icon="pi pi-pencil" class="p-button-success p-button-sm"
                      @click="editItemSubGroup(slotProps.data)"/>
              <!-- <Button class="btn btn-danger"
               @click="openDialog(slotProps.data.id)" >
                <i class="fa fa-trash" aria-hidden="true"></i>
              </Button> -->
              <!-- <Button icon="pi pi-trash" v-if="!slotProps.data.systemOnly" class="p-button-danger p-button-sm" @click="openDialog(slotProps.data.id)"/> -->
              <Button icon="pi pi-trash" class="p-button-danger p-button-sm"
                      @click="openDialog(slotProps.data.id)"/>

            </template>
          </Column>
        </DataTable>
      </div>
      <Dialog v-model="dialogShow" @cancel="cancel" @deleted="deleteItemSubGroup"/>
    </div>
  </section>
</template>
<script>
import DataTable from 'primevue/datatable'
import Column from 'primevue/column'
import Dialog from '../../layout/dialog'
import Button from 'primevue/button'

export default {
  name: 'itemSubGroupList',
  data() {
    return {
      dialogShow: false,
      accountId: ''
    }
  },
  computed: {
    itemSubGroupLists() {
      return this.$store.state.itemgroup.itemSubGroupLists
    }
  },
  mounted() {
    this.itemSubGroupList()
  },
  methods: {
    async itemSubGroupList() {
      await this.$store.dispatch('loadItemSubGroupList')
    },
    async deleteItemSubGroup(value) {
      if (value.trim() === '') {
        let message = {
          message: 'Delete Reason cannot be empty.',
          messageType: 'error'
        }
        this.$emit('delete-message', message)
        this.dialogShow = true
        return
      }
      let deleteRe = {
        itemSubGroupId: this.accountId,
        deleteReason: value
      }
      let resp = await this.$store.dispatch('deleteItemSubGroup', deleteRe)
      if (resp.data.status === 'SUCCESS') {
        let message = {
          message: resp.data.message,
          messageType: 'success'
        }
        this.$emit('delete-message', message)
        this.closeDialog()
      } else {
        let message = {
          message: resp.data.message,
          messageType: 'warn'
        }
        this.$emit('delete-message', message)
      }
    },
    editItemSubGroup(data) {
      this.$emit('edit-group', data)
    },
    cancel(data) {
      // this.show = false
      this.dialogShow = false
    },
    openDialog(id) {
      this.dialogShow = true
      this.accountId = id
    },
    closeDialog() {
      this.dialogShow = false
    }
  },
  components: {
    DataTable,
    Column,
    Dialog,
    Button
  }
}
</script>



// WEBPACK FOOTER //
// itemSubGroupList.vue?038dd470